import Joi from 'joi';

export const VALIDATION_COMPANY_INFO_LIST = {
  options: {allowUnknownBody: false},
  body: {
    name: Joi.string().min(1).max(20),
    taxId: Joi.string().min(1).max(20),
  }
};
  




// WEBPACK FOOTER //
// ./src/services/companyInfo/CompanyInfo.Validator.js